import * as React from 'react';

const TILE = '#121210';
const SCLERA = '#F8F8F7';

/**
 * @param {object} props
 * @param {boolean} [props.inverted] Swap the tile and the sclera.
 *
 * The natural artwork is a near-black tile with a white eye. That is correct on a light surface and
 * disappears on a dark one — the tile measures 1.03:1 against the grey900 shell, so on the Access
 * sidebar the tile was invisible and Vision read as a floating eye beside four solid product tiles.
 * Inverting leaves the mark itself intact and only flips which of the two shapes carries the surface.
 */
const LogoVisionApp = ({ inverted = false, ...props }) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={100} height={100} viewBox='0 0 478 478' fill='none' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M477.956 60.5821V417.375C477.956 450.832 450.833 477.955 417.376 477.955H60.5823C27.1254 477.955 0 450.832 0 417.375V60.5821C0 27.1253 27.1254 0 60.5823 0H417.376C450.833 0 477.956 27.1253 477.956 60.5821Z'
			fill={inverted ? SCLERA : TILE}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M65.3023 251.773C61.7606 248.486 59.6963 243.908 59.6963 239.095C59.6963 234.283 61.7606 229.705 65.3023 226.418C101.9 191.91 168.014 121.722 238.996 121.722C309.978 121.722 375.943 191.91 412.54 226.418C416.23 229.705 418.146 234.283 418.146 239.095C418.146 243.908 416.23 248.486 412.54 251.773C375.943 286.28 309.978 356.469 238.996 356.469C168.014 356.469 101.9 286.28 65.3023 251.773Z'
			fill={inverted ? TILE : SCLERA}
		/>
		{/* Iris and highlight are unchanged in both directions: the deep indigo reads on either
		    sclera, and the highlight is what makes the shape read as an eye rather than a lens. */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M238.953 168.077C199.738 168.077 168.098 199.857 168.098 238.962C168.098 278.067 199.738 309.848 238.953 309.848C278.019 309.848 309.805 278.067 309.805 238.962C309.805 199.857 278.019 168.077 238.953 168.077Z'
			fill='#120C3B'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M272.759 201.032C263.522 201.032 256.069 208.518 256.069 217.73C256.069 226.942 263.522 234.428 272.759 234.428C281.962 234.428 289.449 226.942 289.449 217.73C289.449 208.518 281.962 201.032 272.759 201.032Z'
			fill='#C9C1FA'
		/>
	</svg>
);

export default LogoVisionApp;
